<template>
  <div  class="layout-topbar">
    <button class="p-link layout-menu-button" @click="onMenuToggle">
      <span class="pi pi-bars"></span>
    </button>
    <span class="ml-4 text-bold text-xl" v-if="isEmpresa">[{{ dataEmpresa.data.nombre }}] - {{sruta}}</span
    >
    <span class="p-ml-4 p-text-bold" v-else>[ ]</span>
    <div class="layout-topbar-icons">
      
      <button class="p-link" @click="toggle($event, 'aqui')">
        <span class="layout-topbar-item-text">User</span>
        <span class="layout-topbar-icon pi pi-user"></span>
      </button>
      <OverlayPanel ref="op" class="layout-profile">
        <ul>
          
          <li v-if="isLogged">
            <router-link to="/empresas" @click="toggle($event, 'Empresas')">
              <button class="p-link">
                <i class="pi pi-fw pi-user"></i
                ><span>Lista de Empresas</span>
              </button>
            </router-link>
          </li>
          <li v-if="isLogged">
            <button class="p-link" @click="logout()">
              <i class="pi pi-fw pi-power-off"></i><span>Salir</span>
            </button>
          </li>
          <li v-else>
            <router-link to="/login">
              <button class="p-link">
                <i class="pi pi-fw pi-user"></i><span>Login</span>
              </button>
            </router-link>
          </li>
        </ul>
      </OverlayPanel>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    gRuta: String,
  },
  data: function () {
    return {
      sruta: this.gRuta,
    };
  },
  computed: {
    ...mapGetters(["isLogged", "isEmpresa", "dataEmpresa"]),
  },
  watch: {
    gRuta() {
      this.sruta = this.gRuta;
    },
  },

  methods: {
    toggle(event, data) {
      console.log('toggle....');
      if (data!=undefined)
      this.sruta=data;
      this.$refs.op.toggle(event);
    },
    logout() {
      this.$store.dispatch("logout");
    },
    onMenuToggle(event) {
       console.log('toggle2....');
      this.$emit("menu-toggle", event);
    },
  },
};
</script>
